<template>
	<div class="product-tag">
		<img v-if="product.coverImage" :src="resolveImg(product.coverImage)" class="thumb" />
		<div v-else class="thumb thumb-empty">无图</div>
		<div class="meta">
			<div class="name" :title="product.name">{{ product.name }}</div>
			<div class="price">¥{{ formatPrice(product.retailPrice) }}</div>
		</div>
		<i class="remove" @click.stop="$emit('remove')">
			<el-icon><Close /></el-icon>
		</i>
	</div>
</template>

<script>
import { Close } from '@element-plus/icons-vue';
import globle from '../../globle/globle';

export default {
	name: 'ProductTagItem',
	components: { Close },
	props: {
		product: { type: Object, required: true },
	},
	emits: ['remove'],
	data() {
		return { GLOBAL: globle };
	},
	methods: {
		formatPrice(val) {
			if (val === null || val === undefined) return '0.00';
			return parseFloat(val).toFixed(2);
		},
		resolveImg(url) {
			if (!url) return '';
			if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url;
			const prefix = (this.GLOBAL && this.GLOBAL.imgPath) || '';
			return prefix + url;
		},
	},
};
</script>

<style lang="less" scoped>
.product-tag {
	display: inline-flex;
	align-items: center;
	background: #f6f9ff;
	border: 1px solid #d6e3ff;
	border-radius: 6px;
	padding: 6px 10px 6px 6px;
	margin: 0 10px 10px 0;
	max-width: 280px;
	position: relative;

	.thumb {
		width: 36px;
		height: 36px;
		object-fit: cover;
		border-radius: 4px;
		flex-shrink: 0;
	}
	.thumb-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ddd;
		color: #999;
		font-size: 11px;
	}
	.meta {
		margin-left: 8px;
		min-width: 0;
		.name {
			font-size: 13px;
			color: #333;
			line-height: 1.3;
			max-width: 180px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.price {
			font-size: 13px;
			color: #f56c6c;
			margin-top: 2px;
		}
	}
	.remove {
		margin-left: 8px;
		color: #999;
		cursor: pointer;
		font-size: 14px;
		line-height: 1;
		display: flex;
		align-items: center;
		&:hover { color: #f56c6c; }
	}
}
</style>
